export interface HotJarIdByUrlProps {
  [x: string]: {
    hjid: number; // hotjar id
    hjsv: number; // hotjar snippet version
  };
}

const HOTJAR_ID_BY_URL: HotJarIdByUrlProps = {
  'https://(lowes|lowesime).ee.inscyth.com': {
    hjid: 3185273,
    hjsv: 6,
  },
};

export default HOTJAR_ID_BY_URL;
